module.exports = __webpack_public_path__ + "media/images/riders/small/MATT_WALKER-8dc93442c0b3e8264c01ce789a95c18c.png";